"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentStatsSchema = void 0;
const zod_1 = require("zod");
// Схема для IContentStats
exports.contentStatsSchema = zod_1.z.object({
  likes_count: zod_1.z.number(),
  dislikes_count: zod_1.z.number(),
  comments_count: zod_1.z.number(),
  shares_count: zod_1.z.number(),
  views_count: zod_1.z.number(),
  rating: zod_1.z.number(),
  bookmarks_count: zod_1.z.number()
})
// TODO: remove catchall, need to define all fields
.catchall(zod_1.z.number()); // для [key: string]: number
